import type { GaVueComponent } from "@/common/vueUtils";
import "./gaWizard/_ga-wizard.scss";

function WizardFooter(props: { currentStep: number; maxStep: number; nextButtonConfig?: GaVueComponent; previousButtonConfig?: GaVueComponent }): GaVueComponent {
  const totalSteps = props.maxStep;

  return (
    <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center mt-4">
      <div class="ga-wizard-progress d-flex align-items-center gap-2">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div class={`progress-dot ${i < props.currentStep ? "active" : ""}`} />
        ))}
        <span class="progress-text ms-1">
          {props.currentStep}/{totalSteps}
        </span>
      </div>
      <div class="d-flex gap-2">
        {props.previousButtonConfig !== undefined ? <>{props.previousButtonConfig}</> : null}
        {props.nextButtonConfig !== undefined ? <>{props.nextButtonConfig}</> : null}
      </div>
    </div>
  );
}

function WizardHeader(props: { title?: string; subtitle?: string; description?: string }): GaVueComponent {
  if (props.title === undefined && props.subtitle === undefined && props.description === undefined) {
    return <></>;
  }
  return (
    <div class="mb-3">
      {props.title !== undefined && <h3 class="mb-3">{props.title}</h3>}
      {props.subtitle !== undefined && <h5>{props.subtitle}</h5>}
      {props.description !== undefined && <p class="text-muted">{props.description}</p>}
    </div>
  );
}

export function GaWizard(props: { title?: string; subtitle?: string; description?: string; currentStep: number; maxStep: number; content: GaVueComponent; nextButton?: GaVueComponent; previousButton?: GaVueComponent }): GaVueComponent {
  return (
    <>
      <WizardHeader title={props.title} subtitle={props.subtitle} description={props.description} />
      <div>{props.content}</div>
      <WizardFooter currentStep={props.currentStep} maxStep={props.maxStep} nextButtonConfig={props.nextButton} previousButtonConfig={props.previousButton} />
    </>
  );
}
